function NoMatch() {
  return <div>Page Not found </div>;
}

export default NoMatch;
